import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Configuración de la URL base del API
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';

export const useApi = () => {
  const { jwtToken, logout } = useAuth();
  const navigate = useNavigate();

  // ✅ DEBUG: Verificar qué valor tiene API_BASE_URL
  console.log('🔧 API_BASE_URL from env:', API_BASE_URL);
  console.log('🔧 All env vars:', import.meta.env);

  const apiFetch = async (url: string, options: RequestInit = {}) => {
    // Construir URL completa con prefijo /api
    const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}/api${url}`;
    
    // ✅ DEBUG: Ver exactamente qué URL se está construyendo
    console.log('🔍 URL Construction Debug:', {
      inputUrl: url,
      baseUrl: API_BASE_URL,
      startsWithHttp: url.startsWith('http'),
      finalUrl: fullUrl
    });
    
    // ✅ NO agregar Content-Type si el body es FormData (el navegador lo hace automáticamente con el boundary)
    const isFormData = options.body instanceof FormData;
    
    const headers: HeadersInit = {
      ...(options.headers || {}),
      ...(jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {}),
      // Solo agregar Content-Type si NO es FormData
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    };
    
    try {
      console.log('📡 Making request to:', fullUrl);
      const res = await fetch(fullUrl, { ...options, headers });

      console.log('📡 Response:', {
        url: fullUrl,
        status: res.status,
        statusText: res.statusText,
        ok: res.ok
      });

      // Redirigir a login cuando el token expira (401) - no aplicar a la petición de login
      if (res.status === 401 && !fullUrl.includes('/api/auth/login')) {
        await res.clone().json().catch(() => ({})); // opcional: body.code === 'TOKEN_EXPIRED'
        logout();
        navigate('/login', { replace: true, state: { sessionExpired: true } });
        return res;
      }

      return res;
    } catch (error) {
      console.error('❌ Network error:', error);
      throw error;
    }
  };

  return { apiFetch };
};